import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from "./base.service";
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class TabelaPrecosService extends BaseService {
    constructor(private http: HttpClient) { super(); }

    getTabelaPrecos() {
        return this.http
            .get(this.UrlService + "tabelaPrecos")
            .pipe(map((res: any) => res.data)
                , catchError(super.serviceError));
    }

    getById(id) {
        return this.http
            .get(this.UrlService + `tabelaPrecos/getById/${id}`)
            .pipe(map((res: any) => res.data)
                , catchError(super.serviceError));
    }

    post(tabela: any) {
        return this.http.post(this.UrlService + 'tabelaPrecos', tabela);
    }
}